import React from 'react';
import { LocalizedMessage, LocalizedStandardDate } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import Box from 'components/core/Box';
import Divider from 'components/core/Divider';
import List from 'components/core/List';
// Models
import mAccess from 'models/cpm/access';
// Custom
import { cpmAccessDataShape } from 'constants/PropTypesShapes';
import { dateGenerator } from 'utils/DateUtils';
import InformationItem from 'components/items/InformationItem';
import { DateItem } from 'components/items/InformationItems';
import CarparkDoorItem from 'cpmCarparks/assets/main/CarparkDoorItem';
import CustomerItem from 'cpmCarparks/assets/customers/CustomerItem';

const AccessInfo = ({ access, timezone }) => {
  const {
    date, parking, door, usage,
  } = access;
  // Type
  const { icon: typeIcon, labelId: typeLabelId } = mAccess.type(access);
  // Customer
  const { customer } = parking || {};
  // Usage
  const { labelId: usageLabelId, icon: usageIcon } = mAccess.usage(access) || {};
  // Source
  const { icon: sourceIcon, source } = mAccess.source(access);
  // Result
  const { labelId: resultLabelId, icon: resultIcon, color: resultColor } = mAccess.result(access);

  return (
    <Box type="defaultBackground" className="p-3">
      <List disablePadding>
        <DateItem value={<LocalizedStandardDate value={dateGenerator.dateFromTimezone(date, timezone)} />} light />
        <Divider variant="middle" />
        <InformationItem
          icon={typeIcon}
          value={<LocalizedMessage id={typeLabelId} />}
          light
        />
        <Divider variant="middle" />
        {customer && (
          <React.Fragment>
            <CustomerItem customer={customer} light />
            <Divider variant="middle" />
          </React.Fragment>
        )}
        {usage && (
          <React.Fragment>
            <InformationItem
              icon={usageIcon}
              value={<LocalizedMessage id={usageLabelId} />}
              light
            />
            <Divider variant="middle" />
          </React.Fragment>
        )}
        {door && (
          <React.Fragment>
            <CarparkDoorItem door={door} light />
            <Divider variant="middle" />
          </React.Fragment>
        )}
        {!mAccess.isTriggerDoor(access) && (
          <React.Fragment>
            <InformationItem
              icon={sourceIcon}
              value={(
                <LocalizedMessage
                  id={
                /* eslint-disable */
                access.type === "access"       ? "access.source.access" :
                access.type === "on_demand"    ? "access.source.on_demand" :
                access.type === "trigger_door" ? "access.source.trigger_door" :
                null
              }
              /* eslint-enable */
                  values={{ source }}
                />
)}
              light
            />
            <Divider variant="middle" />
          </React.Fragment>
        )}
        <InformationItem
          icon={resultIcon}
          iconColor={resultColor}
          value={<LocalizedMessage id={resultLabelId} />}
          light
        />
      </List>
    </Box>
  );
};

AccessInfo.propTypes = {
  access: cpmAccessDataShape.isRequired,
  timezone: PropTypes.string.isRequired,
};

module.exports = AccessInfo;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/accesses/AccessInfo.js